module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-MediumOblique.2d177460.woff2";